import { BaseKb3dModel } from '../decorators';
import { eConnectorPositionMode } from '../enums';
import { IBaseConnector } from '../kb3d-models';
import { Kb3dObject } from '../kb3d-object';
import { SpaceNode } from '../meshes/space-node';
import { IKbVectorLike, KbVector } from '../primitives';
import { Token } from '../token';

@BaseKb3dModel({
    token: Token.BaseConnector,
})
export abstract class BaseConnector extends Kb3dObject implements IBaseConnector {
    public enabled: boolean;
    public positionMode: eConnectorPositionMode;
    public position: KbVector;
    public direction: KbVector;
    public angle: number;
    public tag: string;
    public positionZeroToOne: number;
    public interpolateDirection: boolean;

    public _visible: boolean;
    public _isPickable: boolean;
    public _sketchControlPoints: IKbVectorLike[] = [];

    /** Extended by child classes to return the space node parent of this connector */
    public getSpaceParent(): SpaceNode | undefined {
        return undefined;
    }
}
